import jwt_decode from "jwt-decode";

value = "; " + document.cookie;
parts = value.split("; blaize_jwt=");
if (parts.length === 2) {
  var token = parts.pop().split(";").shift();
  var decoded = jwt_decode(token);
  console.log(decoded.sub);
}
